import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AdminService } from '../admin/admin.service';
import { DataToolsApps } from '../shared/DataToolsApps';
import { AuthServiceService } from './auth-service.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  public DataToolsApps = DataToolsApps;

  constructor(private router: Router, private authService: AuthServiceService, private adminService: AdminService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.debug(`intercept auth at ${request.url}`);
    if (this.authService.checkAuthIsValid()) {
      console.debug(`Auth valid. Add token to headers.`);
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.authService.token}`
        }
      });
    } else {
      console.warn('No valid cookie redirect to login');
      this.authService.initialiseAuth();
    }
    return next.handle(request).pipe(
      catchError(error => {
        // TODO: Popup a dialog to inform the user, but ensure there's no loop here.
        if (error.status === 401) {
          this.authService.initialiseAuth();
        } else if (error.status === 403 && !request.url.includes('checkAdminUser')) {
          this.router.navigateByUrl('');
        }
        return throwError(error);
      }));
  }
}
